// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import { setToken } from "./utils/auth";
import plugins from '@/plugins'
import { getDicts } from "@/api/system/dict/data";
import animated from 'animate.css';
import intro from 'intro.js'
import DictTag from '@/components/DictTag'
/* swiper */
import 'swiper/dist/css/swiper.min.css';

//假数据
import '@/mock/mockServe';


// 字典数据组件
import DictData from '@/components/DictData';
import { install } from '@icon-park/vue/es/all';
install(Vue)

import '@icon-park/vue/styles/index.css';
// import 'intro.js/themes/introjs-Nazanin.css'
import 'intro.js/introjs.css';


Vue.use(ElementUI);
Vue.use(plugins);
Vue.use(animated);
Vue.config.productionTip = false
Vue.config.debug = true
import { postMethod, getMethod, putMethod, deleteMethod } from '@/api/config';
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/heimao";

Vue.prototype.$intro = intro
Vue.prototype.$post = postMethod;
Vue.prototype.$get = getMethod;
Vue.prototype.$delete = deleteMethod;
Vue.prototype.$put = putMethod;
Vue.prototype.getDicts = getDicts
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree

Vue.component('DictTag', DictTag)


DictData.install()
//过滤器
Vue.filter('dateFormat', function (originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}`
})

router.beforeEach((to, from, next) => {
  if (to.query.tokenValue) {
    var tokenValue = to.query.tokenValue;
    setToken(tokenValue)
  }
  window.scrollTo(0, 0);
  next();
});

new Vue({
  router,
  store,
  // Base64,

  render: h => h(App)
}).$mount('#app')
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })



// WEBPACK FOOTER //
// ./src/main.js